import React from 'react';
import styles from './PageNotFound.module.scss';

const PageNotFound = () => {
  return (
    <div className={styles.pageNotFoundContainer}>
      <h1>Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
